import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-429d9c5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_contens_list" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["name", "value"]
const _hoisted_4 = { class: "checkbox_text" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["name", "value"]
const _hoisted_8 = { class: "checkbox_text" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "modal_contents_list_item_small" }
const _hoisted_11 = {
  key: 0,
  class: "checkbox"
}
const _hoisted_12 = ["name", "value"]
const _hoisted_13 = { class: "checkbox_text" }

import { PropType, computed, ref, Ref, watchEffect } from 'vue';
import { intersection, remove } from 'lodash';
import { CheckboxListType } from '@/types';
type AccordionItemType = {
  type: 'default' | 'checkbox' | 'radio';
  label: string;
  value: string;
  isOpen: boolean;
  isSelected: boolean;
  hasChildren: boolean;
  children: AccordionItemType[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AccordionCheckbox',
  props: {
  name: {
    type: String,
    default: '',
  },
  list: {
    type: Array as PropType<CheckboxListType[]>,
    default() {
      return [];
    },
  },
  modelValue: {
    type: Array as PropType<string[]>,
    default() {
      return [];
    },
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const value = computed({
  get: () => {
    return props.modelValue;
  },
  set: (value) => {
    const newValue: string[] = value;

    const large = list.value;
    if (large.length < 1) return;

    large.forEach((largeItem) => {
      const largeItemValue = largeItem.value;
      const largeItemType = largeItem.type;

      /** largeItemValueがvalueに含まれているか */
      const hasLargeItemValue = (newValue: string[]) => newValue.includes(largeItemValue);
      const hasPropsLargeItemValue = props.modelValue.includes(largeItemValue);
      const middle = largeItem.children || [];
      if (middle.length < 1) return;
      const middleItemValues = middle.map((item) => item.value);
      /** newValue内のmiddleの値 */
      const middleItemValuesInNewValue = (newValue: string[]) => intersection(newValue, middleItemValues);
      const allSmallItemValues: string[] = [];
      middle.forEach((middleItem) => {
        const middleItemValue = middleItem.value;
        const middleItemType = middleItem.type;
        /** middleItemValueがvalueに含まれているか */
        const hasMiddleItemValue = (newValue: string[]) => newValue.includes(middleItemValue);
        const hasPropsMiddleItemValue = props.modelValue.includes(middleItemValue);
        const small = middleItem.children || [];

        if (small.length < 1) return;
        const smallItemValues = small.map((item) => item.value);
        small.forEach((smallItem) => {
          const smallItemValue = smallItem.value;
          allSmallItemValues.push(smallItemValue);

          /** smallItemValueがvalueに含まれているか */
          const hasSmallItemValue = (newValue: string[]) => newValue.includes(smallItemValue);
          const hasPropsSmallItemValue = props.modelValue.includes(smallItemValue);
          // valueにsmallItem値を含めるのは、
          // 今回チェックされた(valueに値があって、props.modelValueに値がない)
          if (hasSmallItemValue(newValue) && !hasPropsSmallItemValue) {
            if (hasMiddleItemValue(newValue) || hasLargeItemValue(newValue)) {
              if (hasLargeItemValue(newValue)) {
                // largeにチェックが入っていた場合は、他のmiddleにはチェックをいれる
                middleItemValues.filter((n) => !middleItemValuesInNewValue(newValue).includes(n)).forEach((n) => newValue.push(n));
                // 自身以外のsmallにチェックをいれる
                smallItemValues.filter((n) => n !== smallItemValue).forEach((n) => newValue.push(n));
                remove(newValue, (n) => n === smallItemValue);
              }

              // 親を削除する
              remove(newValue, (n) => n === middleItemValue || n === largeItemValue);

              // 自身しか値がない場合は自身も削除する
              if (smallItemValues.length === 1) {
                remove(newValue, (n) => n === smallItemValue);
              }
            }
            return;
          }
          if (hasSmallItemValue(newValue) && hasPropsSmallItemValue) {
            return;
          }
          if (!hasSmallItemValue(newValue) && hasPropsSmallItemValue) {
            remove(newValue, (n) => n === smallItemValue);
            return;
          }
          return;
        });
        if (isSubset(newValue, smallItemValues) && !hasMiddleItemValue(newValue) && middleItemType === 'checkbox') {
          // smallが全部チェックされたら、middleにチェックいれてsmallを全部削除する
          remove(newValue, (n) => smallItemValues.includes(n));
          newValue.push(middleItemValue);
          return;
        }
        /** newValue内のsmallの値 */
        const smallItemValuesInNewValue = (newValue: string[]) => intersection(newValue, smallItemValues);

        // 元々middleが選択されていてsmallが1つ選択された場合はsmallの選択されていない値に変更する
        if (hasPropsMiddleItemValue && smallItemValuesInNewValue(newValue).length === 1) {
          const beforeNewValue = [...newValue];
          remove(newValue, (n) => smallItemValues.includes(n));
          smallItemValues.filter((n) => !smallItemValuesInNewValue(beforeNewValue).includes(n)).forEach((n) => newValue.push(n));
          return;
        }

        // 今回チェックされた(valueに値があって、props.modelValueに値がない)
        if (hasMiddleItemValue(newValue) && !hasPropsMiddleItemValue) {
          // 子(small)をすべて削除する
          remove(newValue, (n) => smallItemValues.includes(n));
          if (hasLargeItemValue(newValue)) {
            // 親を削除する
            remove(newValue, (n) => n === largeItemValue);
            // 自身しか値がない場合は自身も削除する
            if (middleItemValues.length === 1) {
              remove(newValue, (n) => n === middleItemValue);
            }
          }
          return;
        }
        if (hasMiddleItemValue(newValue) && hasPropsMiddleItemValue) {
          return;
        }
        if (!hasMiddleItemValue(newValue) && hasPropsMiddleItemValue) {
          remove(newValue, (n) => n === middleItemValue);
          return;
        }
        return;
      });

      if (isSubset(newValue, middleItemValues) && !hasLargeItemValue(newValue) && largeItemType === 'checkbox') {
        // middleが全部チェックされたら、largeにチェックいれてmiddleを全部削除する
        remove(newValue, (n) => middleItemValues.includes(n));
        newValue.push(largeItemValue);
        return;
      }

      // 元々largeが選択されていてmiddleが1つ選択された場合はmiddleの選択されていない値に変更する
      if (hasPropsLargeItemValue && middleItemValuesInNewValue(newValue).length === 1) {
        const beforeNewValue = [...newValue];
        remove(newValue, (n) => middleItemValues.includes(n));
        remove(newValue, (n) => n === largeItemValue);
        middleItemValues.filter((n) => !middleItemValuesInNewValue(beforeNewValue).includes(n)).forEach((n) => newValue.push(n));
        return;
      }

      // 今回チェックされた(valueに値があって、props.modelValueに値がない)
      if (hasLargeItemValue(newValue) && !hasPropsLargeItemValue) {
        // 子(small)をすべて削除する
        remove(newValue, (n) => middleItemValues.includes(n) || allSmallItemValues.includes(n));
        return;
      }
      if (hasLargeItemValue(newValue) && hasPropsLargeItemValue) {
        return;
      }
      if (!hasLargeItemValue(newValue) && hasPropsLargeItemValue) {
        remove(newValue, (n) => n === largeItemValue);
        return;
      }
      return;
    });

    emit('update:modelValue', newValue.filter((n) => n !== '').sort());
  },
});

/**
 * チェックされているか（valueの中にlistItemValueが含まれているか）
 */
const isChecked = (listItemValue: string) => {
  return value.value.includes(listItemValue);
};

const toggleAccordion = (item: AccordionItemType) => {
  if (item.hasChildren) {
    item.isOpen = !item.isOpen;
  }
};

const list: Ref<AccordionItemType[]> = ref(
  props.list.map((item) => {
    // 子要素があるか
    const hasChildren = !!item.children && item.children.length > 0;

    const children = hasChildren
      ? (item.children as CheckboxListType[]).map((childItem) => {
          // 子要素があるか
          const hasGrandChildren = !!childItem.children && childItem.children.length > 0;
          // 子要素が選択されている場合はあらかじめ開いておく
          const isOpen =
            hasGrandChildren &&
            (childItem.children as CheckboxListType[]).some((grandChildItem) =>
              value.value.some((valueItem) => valueItem === grandChildItem.value)
            );
          // 子要素が選択されている、または自身が選択されているか
          const isSelected = isOpen || value.value.some((valueItem) => valueItem === childItem.value);

          if (!hasGrandChildren) {
            return {
              ...childItem,
              isOpen,
              isSelected,
              hasChildren: hasGrandChildren,
              children: [],
            };
          }

          return {
            ...childItem,
            isOpen,
            isSelected,
            hasChildren,
            children: (childItem.children as CheckboxListType[]).map((grandChildItem) => {
              const isOpen = false;
              const isSelected = value.value.some((valueItem) => valueItem === grandChildItem.value);

              return {
                ...grandChildItem,
                isOpen,
                isSelected,
                hasChildren: false,
                children: [],
              };
            }),
          };
        })
      : [];

    const isOpen = hasChildren && children.some((item) => item.isSelected);
    const isSelected = isOpen || value.value.some((valueItem) => valueItem === item.value);
    return {
      ...item,
      isOpen,
      isSelected,
      hasChildren,
      children,
    };
  })
);

/** array2がarray1に全て含まれているかどうか */
const isSubset = (array1: string[], array2: string[]) => array2.every((element) => array1.includes(element));

watchEffect(() => {
  list.value = list.value.map((largeItem) => {
    const middle = largeItem.children.map((middleItem) => {
      return {
        ...middleItem,
        isSelected:
          middleItem.children.some((smallItem) => value.value.includes(smallItem.value)) || value.value.includes(middleItem.value),
      };
    });

    return {
      ...largeItem,
      children: middle,
      isSelected:
        largeItem.children.some((middleItem) => value.value.includes(middleItem.value)) ||
        value.value.includes(largeItem.value) ||
        middle.some((middleItem) => middleItem.isSelected),
    };
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (large) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: large.label
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal_contents_list_item_large", { 'is-selected': large.isSelected }])
        }, [
          _createElementVNode("span", {
            class: "modal_contents_list_item_large_label",
            onClick: ($event: any) => (toggleAccordion(large))
          }, [
            (large.type === 'checkbox')
              ? (_openBlock(), _createElementBlock("label", {
                  key: 0,
                  class: "checkbox",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "checkbox_input",
                    type: "checkbox",
                    name: props.name,
                    value: large.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
                  }, null, 8, _hoisted_3), [
                    [_vModelCheckbox, _unref(value)]
                  ]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(large.label), 1)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(large.label), 1)
                ], 64))
          ], 8, _hoisted_2),
          (large.hasChildren)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["modal_contents_list_item_accordion_icon", { 'is-open': large.isOpen }]),
                onClick: ($event: any) => (toggleAccordion(large))
              }, null, 10, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(large.children, (middle) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: middle.label
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal_contents_list_item_medium", {
            'is-selected': middle.isSelected || (isChecked(large.value) && middle.hasChildren),
            modal_contents_list_accordion: middle.hasChildren,
          }])
            }, [
              _createElementVNode("span", {
                class: "modal_contents_list_item_medium_label",
                onClick: ($event: any) => (toggleAccordion(middle))
              }, [
                (middle.type === 'checkbox')
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 0,
                      class: "checkbox",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["checkbox_input", { 'is-checked': isChecked(large.value) }]),
                        type: "checkbox",
                        name: props.name,
                        value: middle.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
                      }, null, 10, _hoisted_7), [
                        [_vModelCheckbox, _unref(value)]
                      ]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(middle.label), 1)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(middle.label), 1)
                    ], 64))
              ], 8, _hoisted_6),
              (middle.hasChildren)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["modal_contents_list_item_accordion_icon", { 'is-open': middle.isOpen }]),
                    onClick: ($event: any) => (toggleAccordion(middle))
                  }, null, 10, _hoisted_9))
                : _createCommentVNode("", true)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(middle.children, (small) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                key: small.label
              }, [
                _createElementVNode("div", _hoisted_10, [
                  (small.type === 'checkbox')
                    ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["checkbox_input", { 'is-checked': isChecked(middle.value) || isChecked(large.value) }]),
                          type: "checkbox",
                          name: props.name,
                          value: small.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
                        }, null, 10, _hoisted_12), [
                          [_vModelCheckbox, _unref(value)]
                        ]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(small.label), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])), [
                [_vShow, middle.isOpen]
              ])
            }), 128))
          ])), [
            [_vShow, large.isOpen]
          ])
        }), 128))
      ], 64))
    }), 128))
  ]))
}
}

})